/**
 * PERSON EMAIL ADDRESS API — CRUD degli email di un Person.
 *
 * Contratto backend (rest-openapi.yaml, PeopleResourceImpl):
 *   POST   /person/{personId}/emailAddress                 EmailAddressInput -> EmailAddress
 *   PATCH  /person/{personId}/emailAddress/{emailAddressId} EmailAddressInput -> EmailAddress
 *   DELETE /person/{personId}/emailAddress/{emailAddressId}                   -> 200
 *
 * Pattern per-owner (vs facade polimorfica): il path nested identifica
 * l'owner tramite personId — il body non contiene mai className/classPK.
 * Lo speculare per Business vive in business/businessEmailAddressApi.ts
 * (Step 2). Finche' Business non migra, il thunk polimorfico in
 * emailAddress/emailAddressThunks.ts usa l'api flat legacy per owner
 * Business, e QUESTO api per owner Person.
 *
 * Nota: il backend accetta opzionalmente `listTypeId` (categoria Liferay:
 * personal/work/other). Non lo esponiamo in UI per ora — lo lascia al default.
 */

import { httpClient } from '../../api/httpClient';
import type { EmailAddress } from '../emailAddress/emailAddressTypes';

interface EmailAddressInput {
  address: string;
  primary: boolean;
  listTypeId?: number;
}

const NESTED = (personId: number) => `/person/${personId}/emailAddress`;

export const personEmailAddressApi = {
  create: (personId: number, payload: EmailAddressInput): Promise<EmailAddress> =>
    httpClient.post<EmailAddress>(NESTED(personId), payload).then((r) => r.data),

  update: (
    personId: number,
    emailAddressId: number,
    payload: EmailAddressInput
  ): Promise<EmailAddress> =>
    httpClient
      .patch<EmailAddress>(`${NESTED(personId)}/${emailAddressId}`, payload)
      .then((r) => r.data),

  remove: (personId: number, emailAddressId: number): Promise<void> =>
    httpClient.delete(`${NESTED(personId)}/${emailAddressId}`).then(() => undefined),
};
